<template>
  <div id="rate-graph-bg" class="d-flex">
    <div class="item rate-labels semibold"></div>
    <div class="item days">
      <div class="days-wrapper no-flex" :class="'x' + days_per_screen">
        <div class="d-flex">
          <div
            v-for="day in days"
            :key="'rate-graph-' + day"
            class="day"
            :class="{ weekend: is_weekend(day) }"
            @mouseover="date_hover = day"
            @mouseout="date_hover = ''"
          >
            <div class="day-graph-bg"></div>
          </div>
        </div>
        <div class="rate-graph-wrapper" :class="'x' + days_per_screen">
          <zingchart
            height="250px"
            width="100%"
            :data="graph_data"
            :series="graph_series"
          ></zingchart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
var numeral = require("numeral");

function compareRanking(a, b) {
  if (a.ranking < b.ranking) {
    return -1;
  }
  if (a.ranking > b.ranking) {
    return 1;
  }
  return 0;
}

var tooltips = [];

export default {
  name: "rate-graph-bg",
  //components: {},
  props: ["days", "days_per_screen", "min_graph_value", "max_graph_value"],
  //data: vm => ({}),
  methods: {
    is_weekend(date) {
      var d = Vue.moment(date);
      var dow = d.day();
      return dow > 4 || dow == 0 ? true : false;
    }
  },
  computed: {
    // min_graph_data() {
    //   return this.daily_rates && this.daily_rates.extras
    //     ? this.daily_rates.extras.min_price_scale.bottom_value
    //     : null;
    // },
    // max_graph_data() {
    //   return this.daily_rates && this.daily_rates.extras
    //     ? this.daily_rates.extras.min_price_scale.top_value
    //     : null;
    // },
    graph_data() {
      return {
        type: "mixed",
        gui: {
          contextMenu: {
            empty: true
          }
        },
        plot: {
          aspect: "spline",
          fontFamily: "Roboto Condensed"
        },
        backgroundColor: "none", // This is in the root
        plotarea: {
          backgroundColor: "transparent",
          margin: "5px"
        },
        scaleX: {
          visible: false,
          lineColor: "none",
          item: {
            visible: false
          },
          tick: {
            lineColor: "none"
          }
        },
        scaleY: {
          minValue: this.min_graph_value - 10,
          maxValue:
            this.max_graph_value == this.min_graph_value
              ? this.max_graph_value + 10
              : this.max_graph_value,
          visible: false,
          lineColor: "none",
          item: {
            visible: false
          },
          tick: {
            lineColor: "none"
          }
        },
        tooltip: {
          jsRule: "window.customFncs.formatCrosshair()"
        }
      };
    },
    graph_series() {
      tooltips = [];
      var series = [];

      // --- Serie 1: banda min-max del conjunto de competidores (excluye self) ---
      var onlyCompetitors = this.visible_competitors.filter(c => !c.self);
      var rangeValues = [];
      for (const day of this.days) {
        var dayPrices = [];
        for (const competitor of onlyCompetitors) {
          if (
            this.daily_rates.report &&
            this.daily_rates.report["competitor::" + competitor.id] &&
            this.daily_rates.report["competitor::" + competitor.id][day]
          ) {
            dayPrices.push(
              this.daily_rates.report["competitor::" + competitor.id][day][0]
                .min_price
            );
          }
        }
        rangeValues.push(
          dayPrices.length > 0
            ? [Math.min(...dayPrices), Math.max(...dayPrices)]
            : [null, null]
        );
      }
      series.push({
        type: "range",
        values: rangeValues,
        backgroundColor: "#90caf9",
        alphaArea: 0.35,
        lineWidth: 0,
        marker: { visible: false },
        tooltip: { visible: false }
      });

      // --- Serie 2: línea del hotel actual (self) ---
      var selfCompetitor = this.visible_competitors.find(c => c.self);
      if (selfCompetitor) {
        var selfValues = [];
        for (const day of this.days) {
          if (
            this.daily_rates.report &&
            this.daily_rates.report["competitor::" + selfCompetitor.id]
          ) {
            selfValues.push(
              this.daily_rates.report["competitor::" + selfCompetitor.id][day]
                ? this.daily_rates.report["competitor::" + selfCompetitor.id][
                    day
                  ][0].min_price
                : null
            );
          }
        }
        series.push({
          type: "line",
          values: selfValues,
          lineColor: selfCompetitor.color,
          lineWidth: 2,
          marker: {
            "background-color": selfCompetitor.color,
            size: 3
          }
        });
      }

      // --- Tooltip: bullets de color, hotel actual en negrita ---
      for (const day of this.days) {
        var t =
          "<div style='text-align:left;font-family:\"Roboto Condensed\"'>" +
          "<span style='text-align:left;color:#333333;font-size:13px;font-weight:700;" +
          'font-family:"Roboto Condensed";line-height:30px;\'>' +
          Vue.moment(day).format("dddd, D MMMM YYYY") +
          "</span>";

        // Recogemos self + entradas de competidores con precio
        var selfEntry = null;
        var competitorEntries = [];
        for (const competitor of this.visible_competitors) {
          if (
            this.daily_rates.report &&
            this.daily_rates.report["competitor::" + competitor.id] &&
            this.daily_rates.report["competitor::" + competitor.id][day] &&
            this.daily_rates.report["competitor::" + competitor.id][day][0]
              .min_price > 0
          ) {
            var entry = {
              name: competitor.name,
              color: competitor.color,
              min_price: this.daily_rates.report[
                "competitor::" + competitor.id
              ][day][0].min_price,
              self: this.daily_rates.report["competitor::" + competitor.id][
                day
              ][0].self
            };
            if (entry.self) {
              selfEntry = entry;
            } else {
              competitorEntries.push(entry);
            }
          }
        }

        // Competidor con precio máximo y mínimo
        var maxEntry = null;
        var minEntry = null;
        if (competitorEntries.length > 0) {
          maxEntry = competitorEntries.reduce((a, b) =>
            a.min_price >= b.min_price ? a : b
          );
          minEntry = competitorEntries.reduce((a, b) =>
            a.min_price <= b.min_price ? a : b
          );
        }

        // Construïm les files i les ordenem de major a menor preu
        var tooltipRows = [];
        if (selfEntry) {
          tooltipRows.push({ entry: selfEntry, self: true });
        }
        if (maxEntry) {
          tooltipRows.push({
            entry: maxEntry,
            self: false,
            tag: this.$t("max")
          });
        }
        if (minEntry) {
          tooltipRows.push({
            entry: minEntry,
            self: false,
            tag: this.$t("min")
          });
        }
        tooltipRows.sort((a, b) => b.entry.min_price - a.entry.min_price);

        // Increments respecte la fila següent (de gran a petit)

        // Badge compartit: chip "Màx"/"Mín" o boleta de color — ample fix
        var badgeW = "28px";
        var badgeStyle =
          "display:inline-flex;align-items:center;justify-content:center;" +
          "width:" +
          badgeW +
          ";height:16px;border-radius:10px;font-size:9px;" +
          'font-family:"Roboto Condensed";font-weight:600;';

        t += "<table cellspacing='0' cellpadding='0' style='padding:0'>";
        for (const row of tooltipRows) {
          var fontWeight = row.self ? "font-weight:700;" : "font-weight:400;";
          var number =
            this.l.money_pre_symbol +
            numeral(row.entry.min_price).format(this.l.number_format) +
            this.l.money_post_symbol;

          // Badge: boleta per self, chip per max/min
          var badge = row.self
            ? "<span style='" +
              badgeStyle +
              "'>" +
              "<span style='display:inline-block;width:10px;height:10px;" +
              "border-radius:50%;background:" +
              row.entry.color +
              ";'></span>" +
              "</span>"
            : "<span style='" +
              badgeStyle +
              "background:#eeeeee;color:#666666;'>" +
              row.tag +
              "</span>";

          // Increment respecte la fila següent (última fila no mostra res)
          var rowIndex = tooltipRows.indexOf(row);
          var nextRow = tooltipRows[rowIndex + 1];
          var increment = nextRow
            ? row.entry.min_price - nextRow.entry.min_price
            : 0;
          var incrementHtml =
            increment > 0
              ? "<span style='color:#333333;font-size:11px;" +
                'font-family:"Roboto Condensed"\'>' +
                "+" +
                this.l.money_pre_symbol +
                numeral(increment).format(this.l.number_format) +
                this.l.money_post_symbol +
                "</span>"
              : "";

          t +=
            "<tr>" +
            // Col 1: badge (ample fix)
            "<td style='padding:2px 0;white-space:nowrap;'>" +
            badge +
            "</td>" +
            // Col 2: nom hotel
            "<td style='padding:2px 0 2px 6px;line-height:16px;'>" +
            "<span style='color:#333333;font-size:11px;line-height:16px;" +
            'font-family:"Roboto Condensed";' +
            fontWeight +
            "'>" +
            row.entry.name +
            "</span></td>" +
            // Col 3: preu
            "<td style='padding:2px 0 2px 30px;text-align:right;line-height:16px;white-space:nowrap;' align='right'>" +
            "<span style='color:#333333;font-size:11px;line-height:16px;" +
            fontWeight +
            'font-family:"Roboto Condensed"\'>' +
            number +
            "</span></td>" +
            // Col 4: increment
            "<td style='padding:2px 0 2px 5px;text-align:right;line-height:16px;white-space:nowrap;min-width:38px;' align='right'>" +
            incrementHtml +
            "</td>" +
            "</tr>";
        }
        t += "</table></div>";
        tooltips.push(t);
      }

      return series;
    },
    date_hover: {
      get() {
        return this.$store.state.date_hover;
      },
      set(value) {
        this.$store.dispatch("setRateDateHover", value);
      }
    },
    visible_competitors() {
      return this.competitors.filter(
        c => this.invisible_competitors.indexOf(c.id) < 0
      );
    },
    ...mapState({
      //current_hotel: state => state.hotel.hotel,
      competitors: state => state.rate.competitors,
      invisible_competitors: state => state.rate.invisible_competitors,
      daily_rates: state => state.rate.daily_rates
    }),
    ...mapGetters({
      current_hotel: "current_hotel",
      l: "current_hotel_language"
    })
  },
  mounted() {
    // Global wrapper
    if (!window.customFncs) {
      window.customFncs = {};
    }

    /*
     * Function under our ZC wrapper. Will
     * be fired when the node is hovered over
     *
     * @param {object} p ZingChart callback argument.
     * is associated to various graph properties
     */
    window.customFncs.formatCrosshair = function(p) {
      var text = tooltips[p.key];
      return {
        text: text,
        backgroundColor: "white",
        borderRadius: "3px",
        borderColor: "#cacaca",
        borderWidth: 2,
        lineHeight: "10px",
        // height: "250px",
        // width: "220px",
        htmlMode: true,
        fontFamily: "Roboto Condensed"
      };
    };
  }
};
</script>
